<template>
  <div class="banner-s">
    <img class="banner-s-img" src="../assets/c_banner.jpg" alt="">
  </div>
</template>

<script>

  export default {
    name: "bannerS",
    data() {
      return {
        slide: 0,
        sliding: null,

      }
    },
    mounted() {

    },
    created() {
    },
    methods: {}
  }
</script>

<style scoped>
  .banner-s {
    width: 100vw;
  }

  .banner-s-img {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/bannerS.vue